import { useCallback, useRef, useState } from 'react';

const DEFAULT_KEY = 'default';

function normalizeKey(key) {
  return String(key || DEFAULT_KEY);
}

export function useSubmissionLock() {
  const pendingRef = useRef(new Set());
  const [pendingKeys, setPendingKeys] = useState(() => new Set());

  const syncPendingKeys = useCallback(() => {
    setPendingKeys(new Set(pendingRef.current));
  }, []);

  const isPending = useCallback((key = DEFAULT_KEY) => {
    return pendingRef.current.has(normalizeKey(key));
  }, []);

  const run = useCallback(
    async (key, action) => {
      const lockKey = normalizeKey(typeof key === 'function' ? DEFAULT_KEY : key);
      const task = typeof key === 'function' ? key : action;

      if (typeof task !== 'function') return undefined;
      if (pendingRef.current.has(lockKey)) return undefined;

      pendingRef.current.add(lockKey);
      syncPendingKeys();

      try {
        return await task();
      } finally {
        pendingRef.current.delete(lockKey);
        syncPendingKeys();
      }
    },
    [syncPendingKeys]
  );

  return {
    run,
    isPending,
    pendingKeys,
    anyPending: pendingKeys.size > 0,
  };
}

export default useSubmissionLock;
